module.exports = __webpack_public_path__ + "img/successfailure-failure.8aa25c77.svg";